// Used in profile.module.ts

// Angular
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";

// RXJS/Store
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { Store, select } from "@ngrx/store";
import * as profileStore from "#login/store";

// Services/Types/Helpers
import { FilterMenuHelper } from "#core/helpers/filter-menu.helper";
import { PPUser as User } from "cli-types";
import { LocalStorage } from "#core/services/local-storage.service";

@Component({
    selector: "profile-card-student",
    templateUrl: "./profile-card-student.component.html",
    styleUrls: ["./profile-card-student.component.scss"],
    standalone: false
})
export class ProfileCardStudentComponent implements OnInit, OnDestroy {
    profileData$?: Observable<User>;
    private ngUnsubscribe = new Subject();

    constructor(
        public store_profile: Store<profileStore.UserState>,
        private router: Router,
        private filterMenuHelper: FilterMenuHelper,
        private titleService: Title,
        private localStorage: LocalStorage
    ) {}

    ngOnInit() {
        this.titleService.setTitle("Carnegie Learning - Edit Profile");
        this.profileData$ = this.store_profile.pipe(
            select(profileStore.getUserProfile)
        );
    }

    // Cancel and return to previous Student page
    cancel() {
        const userData = this.localStorage.get("userProfile");
        if (userData.lastCourse !== null) {
            this.router.navigate([
                `/student/courses/${userData.lastCourse}/assignments`,
            ]);
        } else {
            this.router.navigate(["/student"]);
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
